import Crud, { SEARCH, createFacetsGenerator } from '../../api/crud';

import storage from '../../helpers/storage.helpers';

import { QUERY_PROP_FIELDS } from '../../config';

import {
   AUTH_DISCONNECTED, CLIPS_LOADED, CLIPS_LOADING, CLIPS_RESELECTED_FACETS, CLIPS_PAGE_CHANGED,
   CLIPS_CHANGED_CURRENT_FACETS, CLIPS_SEARCHING, ADDED_TO_CART, REMOVED_FROM_CART, CART_LOADED,
   CLIPS_PAGE_SIZE_CHANGED, CLIPS_RESETED_FILTER, AUTH_AUTHENTICATED, CHANGED_SEARCH_MODE,
   SEARCH_CHANGING_TYPE, CHANGED_SEARCH_COUNTER, SEARCH_CHANGED_FIELDS, CLIPS_RESETED_FACETS,
   SHOW_CLEARED, SEARCH_STATE_CHANGED
} from '../mutation-types';
import {
   CLIPS_LOAD, CLIPS_RESELECT_FACETS, CLIPS_CHANGE_PAGE, CLIPS_LOAD_MORE_FACETS, CLIPS_SEARCH,
   CLIPS_CHANGE_PAGE_SIZE, CLIPS_APPLY_NEXT_PAGE, CLIPS_RESET_FILTER, CHANGE_SEARCH_VIEW_MODE,
   SEARCH_CHANGE_TYPE, CLEAR_SEARCH_COUNTER, SEARCH_CHANGE_FIELDS, CLIPS_RESET_FACETS,
   SYNC_SEARCH_STATE
} from '../actions';

import each from 'lodash/each';
import mapKeys from 'lodash/mapKeys';
import find from 'lodash/find';
import some from 'lodash/some';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';

const api = (function _detectAPI() {
   // if (process.env.NODE_ENV !== 'production') {
   //    const Mock = require('../../mocks/search').default;
   //    return new Mock();
   // }
   return new Crud(SEARCH);
})();


const PAGE_SIZE = '32';
const DEFAULT_PAGE_NUMBER = 0;
const VIEW_MODE = 'card';

const STORAGE_GROUP = 'search_page';
const STORAGE_PAGE_SIZE = 'page_size_2';
const STORAGE_VIEW_MODE = 'view_mode';

const _increment = num => ++num;

const LIST_OF_SERIALIZED_FILEDS = [
   'q', 'pageNumber', 'pageSize', 'qprops', 'mode', 'searchType', 'selectedFacets'
];

const DEFAULT_STATE = {
   q: '',
   qprops: QUERY_PROP_FIELDS.map(f => f.field),
   mode: 'list',
   pageNumber: `${DEFAULT_PAGE_NUMBER}`,
   pageSize: PAGE_SIZE,
   loading: false,
   totalCount: 0,
   list: [],
   facets: [],
   selectedFacets: {},
   searchType: '-1',
   counter: 10,

   currentFullListOfFacets: []
};

const getters = {
   isLoadingClips: state => state.loading,
   isEmptyReq: state => !state.q && state.searchType === '-1' && !Object.keys(state.selectedFacets).length,
   isAnyFacetSelected: state => !!Object.keys(state.selectedFacets).length,
   isSearchByAllFields: state => !state.qprops.length || state.qprops.length === QUERY_PROP_FIELDS.length,
   getSearchFields: state => state.qprops,
   getLoadedClips: state => state.list,
   getCurrentPage: state => +state.pageNumber,
   getClipsCount: state => state.totalCount,
   getPageCount: state => Math.ceil(state.totalCount / state.pageSize) - 1, // eslint-disable-line no-magic-numbers
   getItemsPerPage: state => state.pageSize,
   searchString: state => state.q,
   getSearchType: state => state.searchType,
   isFilteredSearch: state => state.searchType !== '-1' || !!Object.keys(state.selectedFacets).length,
   isAllClipsLoaded: state => state.totalCount === state.list.length,
   getFullListOfFacets: state => state.currentFullListOfFacets,
   getSearchViewMode: state => state.mode,
   getSelectedFacets: state => state.selectedFacets,

   getQueryForSerialazing: state => pick(state, LIST_OF_SERIALIZED_FILEDS)
};

const actions = {
   async [CLIPS_LOAD]({ commit, state, rootState, getters }, { loadFacets = true } = {}) {
      commit(CLIPS_LOADING);
      commit(CHANGED_SEARCH_COUNTER, state.counter + 1); // eslint-disable-line no-magic-numbers
      const params = _makeQuery(state, getters);
      params.facets = loadFacets ? '1' : '0';

      try {
         let { items, facets, total } = await api.load(params);
         facets = loadFacets ? facets : state.facets;
         items.forEach(clip => clip.inCart = some(rootState.cart.clips, { videoId: clip.videoId }));
         items.forEach(clip => {
            if (clip.type === 2) {
               clip.id = "FRG:" + clip.tcIn + ":" + clip.tcOut;
            }
         });
         commit(CLIPS_LOADED, { data: items, facets, count: total });
      } catch (e) {
         commit(CLIPS_LOADED, { data: [], facets: [], count: 0 });
      }
   },
   [CLIPS_RESET_FACETS]({ commit, dispatch }) {
      commit(CLIPS_PAGE_CHANGED, DEFAULT_PAGE_NUMBER);
      commit(CLIPS_RESETED_FACETS);
      dispatch(CLIPS_LOAD);
   },
   [CLIPS_RESELECT_FACETS]({ commit, dispatch }, [facet, selected]) {
      commit(CLIPS_PAGE_CHANGED, DEFAULT_PAGE_NUMBER);
      commit(CLIPS_RESELECTED_FACETS, { type: facet.type, selected });
      dispatch(CLIPS_LOAD);
   },
   [CLIPS_CHANGE_PAGE]({ commit, dispatch }, page) {
      commit(CLIPS_PAGE_CHANGED, page);
      dispatch(CLIPS_LOAD, { loadFacets: false });
   },
   [CLIPS_CHANGE_PAGE_SIZE]({ commit, dispatch }, count) {
      commit(CLIPS_PAGE_CHANGED, DEFAULT_PAGE_NUMBER);
      commit(CLIPS_PAGE_SIZE_CHANGED, count);
      dispatch(CLIPS_LOAD, { loadFacets: false });
   },
   [CLIPS_SEARCH]({ commit, dispatch }, search) {
      commit(CLIPS_PAGE_CHANGED, DEFAULT_PAGE_NUMBER);
      commit(CLIPS_SEARCHING, search);
      dispatch(CLIPS_LOAD);
   },
   [SEARCH_CHANGE_TYPE]({ commit, dispatch }, type) {
      commit(CLIPS_PAGE_CHANGED, DEFAULT_PAGE_NUMBER);
      commit(SEARCH_CHANGING_TYPE, type);
      dispatch(CLIPS_LOAD);
   },
   [CLEAR_SEARCH_COUNTER]({ commit }) {
      commit(CHANGED_SEARCH_COUNTER, 1); // eslint-disable-line no-magic-numbers
   },
   [SYNC_SEARCH_STATE]({ commit, dispatch, state }, s) {
      const current = pick(state, Object.keys(s));
      if (isEqual(current, s)) {
         return;
      }
      commit(SEARCH_STATE_CHANGED, s);
      dispatch(CLIPS_LOAD);
   },
   async [CLIPS_APPLY_NEXT_PAGE]({ commit, state, rootState }) {
      commit(CLIPS_LOADING);
      commit(CLIPS_PAGE_CHANGED, _increment(state.pageNumber));
      const params = _makeQuery(state, getters);
      params.facets = '0';
      const { items, total } = await api.load(params);
      items.forEach(clip => clip.inCart = some(rootState.cart.clips, { videoId: clip.videoId }));
      commit(CLIPS_LOADED, { data: [...state.list, ...items], facets: state.facets, count: total });
   },
   async [CLIPS_LOAD_MORE_FACETS]({ state, commit }, { facet, selected }) {
      const { type, total } = facet;
      const params = _makeQuery(state, getters);
      params[type] = selected;
      params.count = total;
      delete params.showId;
      delete params.offset;

      let generator = createFacetsGenerator(type.toLowerCase());
      const api = new Crud(generator);
      const { items } = await api.load(params);
      return commit(CLIPS_CHANGED_CURRENT_FACETS, items);
   },
   [CLIPS_RESET_FILTER]({ commit, dispatch }) {
      commit(CLIPS_RESETED_FILTER);
      dispatch(CLIPS_LOAD);
   },
   [SEARCH_CHANGE_FIELDS]({ commit, dispatch, state }, fields) {
      commit(SEARCH_CHANGED_FIELDS, fields);
      if (state.q) {
         dispatch(CLIPS_LOAD);
      }
   },
   [CHANGE_SEARCH_VIEW_MODE]({ commit }, mode) {
      commit(CHANGED_SEARCH_MODE, mode);
   }
};

const mutations = {
   [SEARCH_STATE_CHANGED](state, s) {
      Object.keys(s).forEach(k => {
         state[k] = s[k];
      });
   },
   [CLIPS_LOADING](state) {
      state.loading = true;
   },
   [CLIPS_LOADED](state, { data, facets, count }) {
      state.list = data;
      state.totalCount = count;
      state.facets = facets;
      state.loading = false;
   },
   [CLIPS_RESELECTED_FACETS](state, { type, selected }) {
      if (selected.length) {
         state.selectedFacets = { ...state.selectedFacets, [type]: selected };
      } else {
         delete state.selectedFacets[type];
         state.selectedFacets = { ...state.selectedFacets };
      }
   },
   [CLIPS_RESETED_FACETS](state) {
      state.selectedFacets = {};
   },
   [CLIPS_RESETED_FILTER](state) {
      state.selectedFacets = {};
      state.searchType = '-1';
   },
   [CLIPS_PAGE_CHANGED](state, page) {
      state.pageNumber = `${page}`;
   },
   [SEARCH_CHANGING_TYPE](state, type) {
      state.searchType = type;
   },
   [CHANGED_SEARCH_COUNTER](state, counter) {
      state.counter = counter;
   },
   [CLIPS_PAGE_SIZE_CHANGED](state, size) {
      state.pageSize = size;
      storage.set(STORAGE_GROUP, STORAGE_PAGE_SIZE, size);
   },
   [CLIPS_CHANGED_CURRENT_FACETS](state, facets = []) {
      state.currentFullListOfFacets = facets;
   },
   [CLIPS_SEARCHING](state, search) {
      state.q = search;
   },
   [ADDED_TO_CART](state, { videoId }) {
      (find(state.list, { videoId }) || {}).inCart = true;
   },
   [REMOVED_FROM_CART](state, { videoId }) {
      (find(state.list, { videoId }) || {}).inCart = false;
   },
   [CART_LOADED](state, cart) {
      state.list.forEach(clip => clip.inCart = some(cart, item => item.videoId === clip.videoId));
   },
   [CHANGED_SEARCH_MODE](state, mode) {
      state.mode = mode;
      storage.set(STORAGE_GROUP, STORAGE_VIEW_MODE, mode);
   },
   [SEARCH_CHANGED_FIELDS](state, fields) {
      state.qprops = fields;
   },
   [SHOW_CLEARED](state) {
      each(DEFAULT_STATE, (val, key) => {
         state[key] = val;
      });
   },

   [AUTH_AUTHENTICATED](state) {
      state.pageSize = storage.get(STORAGE_GROUP, STORAGE_PAGE_SIZE) || PAGE_SIZE;
      state.mode = storage.get(STORAGE_GROUP, STORAGE_VIEW_MODE) || VIEW_MODE;
   },

   [AUTH_DISCONNECTED](state) {
      each(DEFAULT_STATE, (val, key) => {
         state[key] = val;
      });
   }
};

export default {
   state: { ...DEFAULT_STATE },
   getters,
   actions,
   mutations
};

function _makeQuery(state, getters) {
   const zero = 0;
   const params = mapKeys(state.selectedFacets, (arr, key) => key.toLowerCase());
   params.offset = Math.max(state.pageNumber * state.pageSize, zero);
   params.count = state.pageSize; //getters.isEmptyReq ? zero :
   params.q = state.q;
   if (params.q && !getters.isSearchByAllFields) {
      params.qprops = state.qprops;
   }
   if (state.searchType !== '-1') {
      params.type = state.searchType;
   }
   return params;
}
